import { BrowserRouter, Routes, Route, Outlet } from 'react-router-dom';
import { UserProvider } from './contexts/UserContext';
import { useEffect } from 'react';
import { initLightModeObserver } from './utils/lightModeImages';
// CSS
import './assets/css/bundle.min.css';
// Sidebars
import Sidebar from './components/Sidebar';
import SidebarSignUp from './components/SidebarSignUp';
// Sign IN/UP
import SignIn from './pages/SignIn';
import SignUp from './pages/SignUp';
import SignUp2 from './pages/SignUp2';
import SignUp3 from './pages/SignUp3';
import SignUp4 from './pages/SignUp4';
import SignUp5 from './pages/SignUp5';
import RecoPhrase from './pages/RecoPhrase';
// Pages
import Home from './pages/Home';
import Dashboard from './pages/Dashboard';
import KYC from './pages/kyc';
import Dashboard2 from './pages/Dashboard-2';
import Activity from './pages/activity';
import Support from './pages/support';
import ProptTokens from './pages/ProptTokens';
// Importar la nueva página
import Settings from './pages/Settings';
import AdminPage from './pages/admin/AdminPage';
import AdminPageLogin from './pages/admin/AdminPageLogin';
import AdminPageApproved from './pages/admin/AdminPageApproved';
import AdminPageTransactions from './pages/admin/AdminPageTransactions';
import AdminPageTransactionsApproved from './pages/admin/AdminPageTransactionsApproved';
import AdminRouteGuard from './components/AdminRouteGuard';
import AdminAuthRedirect from './components/AdminAuthRedirect'; //
// Hooks
// Nuevo bot
import SuperinterfaceBot from './components/SuperinterfaceBot';

// Layout para rutas que no necesitan autenticación
function Layout() {
   return (
      <main className="ppt_content">
         <Sidebar />
         <div className="ppt_content_body">
            <Outlet />
         </div>
      </main>
   );
}
// Layout para el proceso de SignUp
function LayoutSignUp() {
   return (
      <main className="ppt_content">
         <SidebarSignUp />
         <div className="ppt_content_body">
            <Outlet />
         </div>
      </main>
   );
}
// Layout para rutas autenticadas (Dashboard, KYC)
function LayoutDash() {
   return (
      <main className="ppt_content">
         <Outlet />
      </main>
   );
}
// Nuevo layout para rutas que requieren UserProvider
function ProtectedLayout() {
   return (
      <UserProvider>
         <main className="ppt_content">
            <Outlet />
         </main>
      </UserProvider>
   );
}
function ProtectedLayoutSidebar() {
   return (
      <UserProvider>
         <main className="ppt_content">
            <Sidebar />
            <div className="ppt_content_body">
               <Outlet />
            </div>
         </main>
      </UserProvider>
   );
}
function App() {
   useEffect(() => {
      const cleanup = initLightModeObserver();
      return cleanup;
   }, []);

   return (
      <Routes>
         <Route element={<Layout />}>
            <Route path="/sign-up-2" element={<SignUp2 />} />
            <Route path="/sign-up-3" element={<SignUp3 />} />
            <Route path="/sign-up-4" element={<SignUp4 />} />
            <Route path="/sign-up-5" element={<SignUp5 />} />
            <Route path="/recovery-phrase" element={<RecoPhrase />} />
         </Route>
         <Route element={<ProtectedLayoutSidebar />}>
            <Route path="/" element={<Home />} />
            <Route path="/sign-in" element={<SignIn />} />
         </Route>
         <Route element={<ProtectedLayout />}>
            <Route path="/kyc" element={<KYC />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/dashboard-2" element={<Dashboard2 />} />
            <Route path="/activity" element={<Activity />} />
            <Route path="/support" element={<Support />} />
            <Route path="/propt-tokens" element={<ProptTokens />} />
            <Route path="/settings" element={<Settings />} />
         </Route>
         <Route element={<LayoutSignUp />}>
            <Route path="/sign-up" element={<SignUp />} />
         </Route>
         <Route element={<LayoutDash />}>
         </Route>
         {/* solo el login público */}
         <Route element={<AdminAuthRedirect />}>
            <Route path="/admin" element={<AdminPageLogin />} />
         </Route>
         {/* rutas protegidas colo para admin */}
         <Route element={<AdminRouteGuard />}>
            <Route path="/admin/pending-kyc-users" element={<AdminPage />} />
            <Route path="/admin/approved-kyc-users" element={<AdminPageApproved />} />
            <Route path="/admin/pending-transactions" element={<AdminPageTransactions />} />
            <Route path="/admin/approved-transactions" element={<AdminPageTransactionsApproved />} />
         </Route>
      </Routes>
   );
}
function AppWrapper() {
   return (
      <BrowserRouter basename="/">
         <SuperinterfaceBot />
         <App />
      </BrowserRouter>
   );
}
export default AppWrapper;